module.exports = __webpack_public_path__ + "img/slide3.045dc4d0.jpg";